<template>
  <div>
    <div class="card" style="height: 120px;padding: 18px">
      <a-descriptions size="small" :column="3">
        <a-descriptions-item label="项目名">
          {{ detail.project_name }}
        </a-descriptions-item>
        <a-descriptions-item label="提交人">
          {{ detail.user_name }}
        </a-descriptions-item>
        <a-descriptions-item label="提交时间">
          {{ detail.created_time }}
        </a-descriptions-item>
        <a-descriptions-item label="LLM处理状态">
          <a-tag v-if="detail.status" color="green"> 已打分 </a-tag>
          <a-tag v-else color="orange"> 未打分 </a-tag>
        </a-descriptions-item>
        <a-descriptions-item label="merge详情">
          <a :href="detail.url" target="_blank">{{ detail.url }}</a>
        </a-descriptions-item>
      </a-descriptions>

    </div>
    <div class="container">
      <div class="tree-div card">
        <el-tree
          v-show="fileTree.length > 0"
          ref="mergeTree"
          :data="fileTree"
          :default-expand-all="true"
          node-key="path"
          :current-node-key="currentNodeKey"
          highlight-current
        >
          <template #default="{ node, data }">
            <span class="custom-tree-node father">
              <span class="node-icon">
                <svg class="icon" aria-hidden="true">
                  <use :xlink:href="getIconClass(data.type)" />
                </svg>
              </span>
              <a-tooltip placement="right" :title="node.label">
                <span class="node-title" :style="getTitleClass(node, data)" @click="getCrDetail(data)">
                  {{ node.label }}
                </span>
              </a-tooltip>
              <span class="create-line" @click="getCrDetail(data)">{{ data.create_line }}</span>
            </span>
          </template>
        </el-tree>
      </div>
      <div class="table card">
        <a-table :columns="columns" size="middle" :pagination="false" :data-source="tableData" row-key="id" bolder />
      </div>
    </div>

  </div>
</template>

<script>
import { getMergeDetail } from '@/api/tools/application';
import Accurate from '@/api/project/accurate';

export default {
  data() {
    return {
      id: null,
      fileTree: [],
      tableData: [],
      currentNodeKey: null,
      columns: [{
        title: '规则项',
        key: 'category',
        dataIndex: 'category',
        align: 'center',
        width: 300
      },
      {
        title: '改进建议',
        dataIndex: 'detail',
        key: 'detail'
      }],
      detail: {}
    };
  },
  mounted() {
    this.getId();
  },
  methods: {
    getId() {
      this.id = this.$route.query.id;
      getMergeDetail({ id: this.id }).then(res => {
        this.detail = { ...res.data };
        this.fileTree = Accurate.getTreeDTO(
          Object.entries(res.data.detail).map(([key, value]) => ({ path: key, content: value, create_line: value.length }))
        );
        const first = this.findFirstFileNode(this.fileTree);
        if (first) {
          this.currentNodeKey = first.path;
          this.getCrDetail(first);
          this.$nextTick(() => {
            if (this.$refs.mergeTree && this.$refs.mergeTree.setCurrentKey) {
              this.$refs.mergeTree.setCurrentKey(first.path);
            }
          });
        }
      });
    },
    findFirstFileNode(list) {
      if (!list) return null;
      for (let i = 0; i < list.length; i += 1) {
        const item = list[i];
        if (item && item.type !== 'folder') return item;
        if (item && item.children && item.children.length) {
          const found = this.findFirstFileNode(item.children);
          if (found) return found;
        }
      }
      return null;
    },
    getIconClass(val) {
      const fileTypeList = ['folder', 'go', 'vue', 'png', 'css', 'html', 'js'];
      if (fileTypeList.indexOf(val) > -1) {
        return '#icon-' + val;
      } else {
        return '#icon-unknown.svg';
      }
    },
    getTitleClass(node, data) {
      if (!data.status) {
        return;
      }
      switch (data.status) {
        case 1:
          return 'color:#1E90FF';
        case 2:
          return 'color:#13CD54';
        case 3:
          return 'color:#909399;text-decoration:line-through';
        case 4:
          return 'color:#FF4500';
      }
    },
    getCrDetail(val) {
      this.tableData = val.content;
    }
  }
};
</script>

<style scoped lang="less">
.card {
  transition: box-shadow 0.2s;
  &:hover {
    box-shadow: 0 4px 24px 0 rgba(24,144,255,0.12);
    border-color: #1890ff;
  }
  background: #fff;
  border: 1px solid #f0f0f0;
  box-shadow: 0 2px 16px 0 rgba(0,0,0,0.06);
  border-radius: 14px;
}

.container {
  margin-top: 10px;
  display: flex;
  height: 75vh;
  width: 100%;
  // background: #f5f7fa;
  // padding: 32px 0;
  box-sizing: border-box;
  align-items: stretch;
  justify-content: center;

  .tree-div {
    width: 30%;
    min-width: 260px;
    height: 100%;
    overflow: auto;
    padding: 18px 12px 12px 12px;
    transition: box-shadow 0.2s;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  .table {
    flex: 1;
    min-width: 0;
    height: 100%;
    width: 70%;
    margin-left: 10px;
    padding: 18px 18px 12px 18px;
    overflow: auto;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
}

.custom-tree-node {
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 15px;
  padding: 6px 8px 6px 0;
  width: 100%;
  border-radius: 6px;
  transition: background 0.2s;
  cursor: pointer;
  &:hover {
    background: #e6f7ff;
    .node-title {
      color: #1890ff;
    }
  }
}

.icon {
  width: 1.3em;
  height: 1.3em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
  margin-right: 6px;
}

.node-title {
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1 1 auto;
  padding: 0 5px;
  overflow: hidden;
  font-weight: 600;
  color: #222;
  transition: color 0.2s;
}

.create-line {
  color: #13cd54;
  font-size: 13px;
  margin-left: 8px;
  font-weight: 500;
}

// 优化表格样式
::v-deep .ant-table {
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
}
::v-deep .ant-table-thead > tr > th {
  background: #f0f5ff;
  font-weight: 600;
  font-size: 15px;
  color: #222;
}
::v-deep .ant-table-tbody > tr > td {
  font-size: 14px;
  color: #444;
  background: #fff;
}
::v-deep .ant-table-row:hover > td {
  background: #e6f7ff !important;
}

// 响应式
@media (max-width: 900px) {
  .container {
    flex-direction: column;
    padding: 12px 0;
    .tree-div, .table {
      width: 100% !important;
      min-width: 0;
      max-width: none;
      margin: 0 0 18px 0;
      height: auto;
    }
    .divider {
      display: none;
    }
  }
}
</style>
